import React from 'react';

import { Flex, Image } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { TextType } from '../models/Text';

import Text from './Text';

interface LogoProps {
  logoPath: string;
  size?: number;
  color?: string;
  withText?: boolean;
}

const Logo = ({
  logoPath,
  color = 'white',
  size = 100,
  withText = true,
}: LogoProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const handleClickLogo = () => {
    if (location.pathname === '/') {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    } else {
      navigate('/');
    }
  };

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      paddingY="10px"
      onClick={handleClickLogo}
      cursor="pointer"
    >
      <Flex
        width={`${size}px`}
        height={`${size}px`}
        alignItems="center"
        justifyContent="center"
        borderRightColor={color}
        borderRightWidth={withText ? 1 : 0}
        flexShrink={0}
      >
        <Image
          src={logoPath}
          alt="arch4D"
          width="100%"
          height="100%"
          objectFit="contain"
          display="block"
        />
      </Flex>

      {withText && (
        <Flex
          flexDirection="column"
          marginLeft="10px"
        >
          {t('header.logoTitle')
            .split(' ')
            .map((item, index) => (
              <Text
                key={`item-${index}-${item}`}
                type={{
                  base: TextType.Inter14Regular,
                  md: TextType.Inter14Regular,
                }}
                others={{
                  textTransform: 'uppercase',
                }}
                color={color}
              >
                {item}
              </Text>
            ))}
        </Flex>
      )}
    </Flex>
  );
};

export default Logo;